import classNames from 'classnames/bind';
import React from 'react';

import { ClosedCircle } from '../../assets/icons/Icons';
import Styles from './chip.module.scss';

const cx = classNames.bind(Styles);

interface CommonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  pill?: boolean;
  big?: boolean;
  highlight?: 'blue' | 'dark' | 'light' | null;
  fullWidth?: boolean;
  noRemoval?: boolean;
  color?: string;
  colorText?: string;
}

type EditableProps =
  | {
      editable: true;
      onClick: React.MouseEventHandler<HTMLButtonElement>;
    }
  | {
      editable?: boolean;
      onClick?: React.MouseEventHandler<HTMLButtonElement>;
    };

type Props = CommonProps & EditableProps;

const Chip = ({
  label,
  onClick,
  editable,
  children,
  pill,
  big,
  highlight,
  fullWidth,
  noRemoval = false,
  color,
  colorText,
  ...otherProps
}: Props) => {
  return onClick ? (
    <button
      {...otherProps}
      onClick={onClick}
      disabled={!editable}
      className={cx(
        'chip',
        { 'chip-editable': editable },
        highlight,
        { 'full-width': fullWidth },
        otherProps.className,
      )}>
      <span className={Styles['chip-label']}>{children || label}</span>
      {editable && !noRemoval ? ClosedCircle : ''}
    </button>
  ) : (
    <div
      className={cx('chip', { pill }, highlight, { big }, { 'full-width': fullWidth })}
      style={{ backgroundColor: color, color: colorText }}>
      {children || label}
    </div>
  );
};

export default Chip;
